var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"video-card-tags"},_vm._l((_vm.tagsToDisplay),function(tag,i){return _c('div',{key:i,staticClass:"video-card-tag"},[_vm._v("#"+_vm._s(tag)+" ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }